import { ReactNode, PropsWithChildren, useLayoutEffect } from 'react';

/**
 * ContentBody component for wrapping the content of the body (alerts and value).
 */
function ContentBody({
  alerts,
  children,
  scrollableTable,
}: PropsWithChildren<{ alerts?: ReactNode; scrollableTable?: boolean }>) {
  useLayoutEffect(() => {
    if (scrollableTable) {
      document.body.classList.add('scrollable-table');

      return () => {
        document.body.classList.remove('scrollable-table');
      };
    }
  }, [scrollableTable]);

  return (
    <div className="content-body">
      <div className="content-body-alerts">
        <div className="max-container">{alerts}</div>
      </div>
      <div className="content-body-value">
        <div className="max-container">{children}</div>
      </div>
    </div>
  );
}

export default ContentBody;
